import PropTypes from 'prop-types'

import { BlockWrapper, Container } from 'common/widgets'
import classNames from './styles.module.scss'


Content.propTypes = {
  data: PropTypes.shape({
    body: PropTypes.string,
  }),
}

export default function Content({
  data = {},
}) {
  return (
    <BlockWrapper spacing="content">
      <Container size="xl">
        <div className={classNames.content} dangerouslySetInnerHTML={{ __html: data.body }} />
      </Container>
    </BlockWrapper>
  )
}
